import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">COMMON MISCONCEPTIONS</span>
                                            </div>
                                            <p>There are a number of common myths about how a role model should
                                                look or behave – some of
                                                which are examined below:</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport uiheading ilead_v_sport_new_task">
                                                <tbody>
                                                <tr>
                                                    <th width="15%" align="left" valign="top"
                                                        className="green_curve ">Myth
                                                    </th>

                                                    <th width="37%" align="left" valign="top"
                                                        className=" green_curve1">Reality Check
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="15%" align="left" valign="middle"
                                                        className="lightgreen">
                                                        <div className=""><p>You need to be
                                                            ‘charismatic’ to
                                                            be an effective
                                                            role model</p></div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <ul className="greenbullet-list">
                                                            <li>Charismatic people are often seen as being
                                                                outgoing, sociable and
                                                                ‘lighting up a room’. They may be people who can
                                                                inspire others or
                                                                have a passion for what they do.
                                                            </li>
                                                            <li>These attributes may be useful and there are,
                                                                and have been, many
                                                                charismatic leaders and role models. However, it
                                                                really does depend on
                                                                what you are trying to embody. If you are
                                                                showing good practice
                                                                around a procedure do you need to be
                                                                charismatic? No, and this is a
                                                                common myth that can be put aside.
                                                            </li>
                                                            <li><span className="subtiltereg">You do not NEED to be charismatic to be an effective role model.</span>
                                                            </li>

                                                        </ul>
                                                    </td>

                                                </tr>

                                                <tr>
                                                    <td width="15%" align="left" valign="middle"
                                                        className="darkgreen">
                                                        <div className=""><p>You have to
                                                            be seriously
                                                            successful to
                                                            be considered
                                                            a role model
                                                        </p></div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="darkgreen">
                                                        <ul className="greenbullet-list">
                                                            <li>Success is often one of the key elements of a
                                                                role model. The most
                                                                crucial aspect is to understand what success
                                                                actually means in each
                                                                situation and why this is particularly
                                                                important.
                                                            </li>
                                                            <li>Often it is not the outcome but the approach
                                                                that is the important part
                                                                of the action or behaviour. Of course, success
                                                                can be a good
                                                                benchmark of whether behaviour works or not, but
                                                                role models do not
                                                                have to be extremely rich or have high status or
                                                                power.
                                                            </li>
                                                            <li><span className="subtiltereg">You do not HAVE to be seriously successful to be considered
                        a role model.</span></li>

                                                        </ul>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="15%" align="left" valign="middle"
                                                        className="lightgreen">
                                                        <div className=""><p>I couldn’t be a
                                                            role model</p></div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <ul className="greenbullet-list">
                                                            <li>A lot of people may not consider themselves to
                                                                be the right ‘material’
                                                                to be role models. This may link to the
                                                                ‘charisma myth’. However, there
                                                                is no reason why you cannot be considered a role
                                                                model. Look at what
                                                                you are doing, how you are doing it and what you
                                                                have achieved.
                                                            </li>
                                                            <li>When you start to take a look at yourself you
                                                                should be able to find
                                                                some aspects that you find important and that
                                                                you embody and that
                                                                other people would look up to.
                                                            </li>
                                                            <li><span
                                                                className="subtiltereg">You CAN be a role model.</span>
                                                            </li>

                                                        </ul>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td width="15%" align="left" valign="middle"
                                                        className="darkgreen">
                                                        <div className=""><p>Role models are
                                                            good at everything</p></div>
                                                    </td>
                                                    <td width="37%" align="left" valign="top"
                                                        className="darkgreen">
                                                        <ul className="greenbullet-list">
                                                            <li>Many people make the mistake of looking at role
                                                                models and taking
                                                                their good qualities out of proportion and
                                                                projecting this onto their
                                                                whole being.
                                                            </li>
                                                            <li>Role models often show bad behaviours as well as
                                                                good ones. It is
                                                                often a particular aspect that you may admire in
                                                                someone. Be careful
                                                                not to project this attribute to an overall view
                                                                of someone without good
                                                                evidence.
                                                            </li>
                                                            <li>Role models are not perfect; they too have their
                                                                faults. Often you can
                                                                have more than one role model and concentrate on
                                                                different qualities
                                                                for each person.
                                                            </li>
                                                            <li><span className="subtiltereg">You do NOT have to be good at everything to be a role model.</span>
                                                            </li>

                                                        </ul>
                                                    </td>

                                                </tr>
                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}